import { useEffect, useState } from 'react';
import type { StepProps } from '../engine/context.ts';
import { TitleBlock } from '../ui/TitleBlock.tsx';
import { INK, LINE, ORANGE, PAPER, SHADOW_CARD } from '../ui/theme.ts';

/** text-input: one big centred field. Answer: { value, label } (both the trimmed text). */
export function TextInput({ step, content, ctx }: StepProps) {
  const key = step.answerKey!;
  const [value, setValue] = useState('');
  const trimmed = value.trim();
  const valid = trimmed.length > 0 && trimmed.length <= 40;

  const submit = () => {
    if (!valid) return;
    ctx.setAnswer(key, { value: trimmed, label: trimmed });
    ctx.next();
  };

  useEffect(() => {
    ctx.setCta({ label: content.cta ?? ctx.shared.ui?.continue ?? 'Continue', disabled: !valid, large: true, onPress: submit });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step.id, trimmed, valid, content.cta]);

  return (
    <>
      <TitleBlock label={content.label} title={content.title} highlight={content.highlight} subtitle={content.subtitle} />
      <input
        className="fk-input"
        type="text"
        autoFocus
        autoComplete="off"
        autoCapitalize="words"
        enterKeyHint="next"
        maxLength={40}
        value={value}
        aria-label={content.title ?? 'Name'}
        placeholder={content.placeholder ?? ''}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit();
        }}
        style={{
          width: '100%',
          minHeight: 64,
          padding: '12px 18px',
          borderRadius: 18,
          font: 'inherit',
          fontWeight: 800,
          fontSize: 24,
          textAlign: 'center',
          background: PAPER,
          color: INK,
          border: `2px solid ${valid ? ORANGE : LINE}`,
          boxShadow: SHADOW_CARD,
        }}
      />
    </>
  );
}
